export default function AdminPackageTypeListItem(props)
{
    return (
        <div className="Job mobilePanel">
                 <span className='title'>{props.packageItemType.Text}</span>
        </div>
    );
}

